import React, { useEffect, useState } from 'react';
import { getScratches, setGift } from '../../api/campaign';
import { Dropdown, DropdownItem, Table, TableBody, TableCell, TableHead, TableHeadCell, TableRow, Modal, ModalBody, ModalHeader, Spinner, Button } from "flowbite-react";
import img from '../../scratch_foreground.jpg';

export default function ReloadDash() {
    const [details, setDetails] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [loadError, setLoadError] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [imageUrl, setImageUrl] = useState('');
    // const [imagePath, setImagePath] = useState('');

    useEffect(()=>{
        let newFilteredItems = [];
        // Was: innovate winners only. Atlas-only campaign, so show all winners.
        newFilteredItems = details.filter(item => item.s === 1);
        setFilteredData(newFilteredItems);
    },[details]);

    const filterdDataByBranding = (val) => {
        let newFilteredItems = [];
        // Always filter from the full dataset
       if(val === 'g_pen') {
            newFilteredItems = details.filter(item => item.atlas?.toLowerCase().includes('x') && item.r === 0 && item.s === 1);
        }else if(val === 'g_done') {
            newFilteredItems = details.filter(item => item.atlas?.toLowerCase().includes('x') && item.r === 1 && item.s === 1);
        }else {
            newFilteredItems = details; // fallback
        }

        setFilteredData(newFilteredItems);
    };

    // bill_img is now a direct URL in the file store, so there is nothing to fetch
    const getImage = (billImg) => setImageUrl(billImg || '');

    useEffect(() => {
        getDetails();
    }, []);

    // useEffect(() => {
    //     if (!openModal) return;
    //     const timer = setTimeout(async () => {
    //     try {
    //         const img = await import('../../scratch_foreground.jpg');
    //         setImagePath(img.default);
    //         console.log("This message appears after 4 seconds.");
    //     } catch (err) {
    //         console.error("Failed to load image:", err);
    //     }
    // }, 4000);
    
    // return () => clearTimeout(timer);
    // }, [openModal]);

    // A second useEffect on [details] used to run after the winners filter above
    // and reset filteredData to every row, so the winners-only view never
    // actually applied. Removed -- this page is the gift handover list.

    const getDetails = async () => {
        setIsLoading(true);
        setLoadError('');
        try {
            setDetails(await getScratches());
        } catch (err) {
            console.error("error fetching data: ", err);
            setLoadError('Could not load data. Tap retry.');
        } finally {
            setIsLoading(false);
        }
    };

    const giftManage =async(id)=>{
        try {
            await setGift(id, 1);
        } catch (err) {
            console.error("error saving gift: ", err);
        }

        setTimeout(()=>{window.location.reload()},1000);
    };

    return (
        <>
            <div className='flex flex-col text-center'>
                <h1 className='py-4 text-3xl font-bold'>Gift Handover</h1>

                <div className='px-8 py-4'>
                    <div className='flex gap-12'>
                        <Dropdown label="Select Gift">
                            <DropdownItem onClick={() => filterdDataByBranding('g_pen')}>Pending</DropdownItem>
                            <DropdownItem onClick={() => filterdDataByBranding('g_done')}>Done</DropdownItem>
                        </Dropdown>
                    </div>
                </div>

                {isLoading ? (
                    <div className="py-16 text-center">
                        <Spinner size="xl" />
                        <p className="mt-3 text-sm text-gray-500">Loading data&hellip;</p>
                    </div>
                ) : loadError ? (
                    <div className="py-16 text-center">
                        <p className="mb-3 text-red-600">{loadError}</p>
                        <Button onClick={getDetails}>Retry</Button>
                    </div>
                ) : (
                <div className="overflow-x-auto px-8">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableHeadCell>Name</TableHeadCell>
                                <TableHeadCell>Tp</TableHeadCell>
                                <TableHeadCell>Shop Name</TableHeadCell>
                                <TableHeadCell>Win</TableHeadCell>
                                <TableHeadCell>Gift</TableHeadCell>
                                <TableHeadCell><span className="sr-only">Bill</span></TableHeadCell>
                                <TableHeadCell>Action</TableHeadCell>
                            </TableRow>
                        </TableHead>
                        <TableBody className="divide-y">
                            {filteredData.map((data, index) => (
                                <TableRow key={index} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                                    <TableCell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                        {data.name}
                                    </TableCell>
                                    <TableCell>{data.tp}</TableCell>
                                    <TableCell>{data.shopName}</TableCell>
                                    <TableCell>{data.s === 0 ? 'Lost' : 'Win'}</TableCell>
                                    <TableCell>{data.giftName || '-'}</TableCell>
                                    <TableCell>
                                        <a href="#" onClick={() => {setOpenModal(true); getImage(data.bill_img);}} className="font-medium text-primary-600 hover:underline dark:text-primary-500">
                                            Bill View
                                        </a>
                                    </TableCell>
                                    <TableCell>
                                        {data.r == 0 && data.s == 1
                                            ? <Button onClick={() => giftManage(data.id)}>Gift Received</Button>
                                            : data.r == 1 ? 'Gift Given!' : '-'}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
                )}
            </div>
            <>
                <Modal show={openModal} onClose={() => {setOpenModal(false); setImageUrl(null);}}>
                    <ModalHeader>Bill Image</ModalHeader>
                    <ModalBody>
                        {imageUrl ?
                            <div className='flex justify-center items-center'>
                                <img src={imageUrl} alt="Bill" className="max-h-[70vh] w-auto object-contain" />
                            </div>
                            :
                            <>
                                <div className="text-center">
                                    <Spinner aria-label="Center-aligned Large  spinner example" />
                                </div>
                            </>}
                    </ModalBody>
                </Modal>
            </>

        </>
    );
}